import { Card, CardContent, Typography, Stack } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { LabelValueRow } from './LabelValueRow';

interface PotSummaryCardProps {
  ownerType: 'Gang' | 'Solo';
  ownerName: string;
  period: {
    weekNumber: number;
    year: number;
    start: string;
    end: string;
  };
}

export function PotSummaryCard({
  ownerType,
  ownerName,
  period,
}: PotSummaryCardProps) {
  const formatDateRange = (start: string, end: string) => {
    const startDate = parseISO(start);
    const endDate = parseISO(end);
    const startFormatted = format(startDate, 'dd MMM');
    const endFormatted = format(endDate, 'dd MMM yyyy');
    return `${startFormatted} - ${endFormatted}`;
  };

  return (
    <Card variant="outlined">
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Summary
        </Typography>
        <Stack spacing={2}>
          <LabelValueRow
            label={ownerType === 'Gang' ? 'Gang' : 'Worker'}
            value={ownerName}
            valueWeight="medium"
          />
          <LabelValueRow
            label="Period"
            value={`Week ${period.weekNumber}, ${period.year}`}
          />
          <LabelValueRow
            label="Dates"
            value={formatDateRange(period.start, period.end)}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
